import React from 'react';
import { RED, INK, GREY, LIGHT, TEAL, BORDER, wrap, Hero, Crumbs, CtaBand } from '../seo/SeoUI';
import { COMPARE_PAGES } from './data';

function Compare({ slug, data }) {
  const others = Object.keys(COMPARE_PAGES)
    .filter((k) => k !== slug)
    .map((k) => ({ slug: k, label: COMPARE_PAGES[k].competitor ? `BestHand vs ${COMPARE_PAGES[k].competitor}` : 'Best handyman app' }));
  const title = data.h1;
  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    { label: 'Compare', href: '/compare/' + slug },
    { label: data.competitor ? data.competitor + ' alternative' : 'Best handyman app' },
  ];

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: data.title,
      description: data.metaDescription,
      publisher: { '@type': 'Organization', name: 'BestHand' },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.map((b, i) => ({
        '@type': 'ListItem', position: i + 1, name: b.label, ...(b.href ? { item: b.href } : {}),
      })),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: data.faqs.map(([q, a]) => ({
        '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a },
      })),
    },
  ];

  return (
    <div style={{ background: '#fff' }}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      <Hero
        breadcrumb={<Crumbs items={breadcrumbItems} />}
        title={title}
        subtitle={data.intro}
      >
        <a href="/category?type=all" style={{ display: 'inline-block', padding: '13px 22px', borderRadius: 12, background: RED, color: '#fff', fontWeight: 700, fontSize: 16, textDecoration: 'none' }}>Book a trusted pro</a>
      </Hero>

      <section style={{ ...wrap, padding: '48px 20px 8px' }}>
        <h2 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 24px' }}>Why people choose BestHand{data.competitor ? ' over ' + data.competitor : ''}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 18 }}>
          {data.reasons.map(([t, d], i) => (
            <div key={i} style={{ background: LIGHT, borderRadius: 16, padding: '24px 22px', border: `1px solid ${BORDER}` }}>
              <div style={{ width: 40, height: 40, borderRadius: 999, background: i % 2 ? TEAL : RED, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, marginBottom: 14 }}>✓</div>
              <h3 style={{ fontSize: 18, fontWeight: 700, margin: '0 0 8px', color: INK }}>{t}</h3>
              <p style={{ fontSize: 15, color: GREY, margin: 0, lineHeight: 1.6 }}>{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ background: LIGHT, borderTop: `1px solid ${BORDER}`, borderBottom: `1px solid ${BORDER}`, marginTop: 40 }}>
        <div style={{ ...wrap, padding: '46px 20px' }}>
          <h2 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 22px' }}>Frequently asked questions</h2>
          <div style={{ display: 'grid', gap: 14 }}>
            {data.faqs.map(([q, a], i) => (
              <div key={i} style={{ background: '#fff', borderRadius: 14, padding: '20px 22px', border: `1px solid ${BORDER}` }}>
                <h3 style={{ fontSize: 17, fontWeight: 700, margin: '0 0 8px', color: INK }}>{q}</h3>
                <p style={{ fontSize: 15, color: GREY, margin: 0, lineHeight: 1.6 }}>{a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {others.length > 0 ? (
        <section style={{ ...wrap, padding: '36px 20px' }}>
          <h2 style={{ fontSize: 22, fontWeight: 800, margin: '0 0 16px' }}>See also</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
            {others.map((o) => (
              <a key={o.slug} href={`/compare/${o.slug}`} style={{ display: 'inline-block', padding: '10px 16px', borderRadius: 999, border: `1px solid ${BORDER}`, background: '#fff', color: INK, fontWeight: 600, fontSize: 14, textDecoration: 'none' }}>{o.label}</a>
            ))}
          </div>
        </section>
      ) : null}

      {/* COMPLIANCE: background-check claim is intentional (founder confirms BestHand performs background checks). LEGAL_REVIEW_REQUIRED before prod. */}
      <CtaBand title="Ready to get it done with BestHand?" subtitle="Book a background-checked local pro in minutes." ctaText="Get started" ctaHref="/category?type=all" />
    </div>
  );
}

export default Compare;
